import Shape from "../Main/Shape.js";
import Action from "./Action";
import {Serialization} from "../Main/Serializer";

export default class ShapeSortAction implements Action {

    private readonly oldIndex: number;

    constructor(
        readonly shape: Shape,
        readonly newIndex: number,
    ) {
        this.oldIndex = this.shape.shapeCollection.getShapes().indexOf(shape);
    }

    public apply() {
        this.shape.shapeCollection.moveShapeInList(this.shape, this.newIndex);
    }

    public revert() {
        this.shape.shapeCollection.moveShapeInList(this.shape, this.oldIndex);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            oldIndex: this.oldIndex,
            newIndex: this.newIndex,
        };
    }
}
